// Auto-generated skeleton for Revision

import { User } from "./User";
import { ReadBy } from "./ReadBy";

export const Revision: Api.Revision = {
  id: 0,
  created: null,
  updated: null,
  revisionable_type: '',
  revisionable_id: 0,
  user_id: 0,
  field_name: '',
  previous_value: '',
  current_value: '',
  user: User,
  model: '',
  readconfirmations: [ReadBy],
  linked_model: '',
  linked_model_type: null,
  linked_model_id: 0,
  children: null,
};

